import { NgModule } from '@angular/core';
import { CommonModule, CurrencyPipe, DatePipe } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatSidenavModule } from '@angular/material/sidenav';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { MatListModule } from '@angular/material/list';
import { MatMenuModule } from '@angular/material/menu';
import { MatIconModule } from '@angular/material/icon';
import { MatRippleModule } from '@angular/material/core';
import { OverlayModule } from '@angular/cdk/overlay';
import { GoogleMapsModule } from '@angular/google-maps';

import { TableModule } from 'primeng/table';
import { OverlayPanelModule } from 'primeng/overlaypanel';
import { AccordionModule } from 'primeng/accordion';
import { PanelModule } from 'primeng/panel';
import { ScrollPanelModule } from 'primeng/scrollpanel';
import { InputTextModule } from 'primeng/inputtext';
import { DropdownModule } from 'primeng/dropdown';
import { InputSwitchModule } from 'primeng/inputswitch';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { CalendarModule } from 'primeng/calendar';
import { TabViewModule } from 'primeng/tabview';
import { MultiSelectModule } from 'primeng/multiselect';
import { InputTextareaModule } from 'primeng/inputtextarea';
import { DialogModule } from 'primeng/dialog';
import { FieldsetModule } from 'primeng/fieldset';
import { RadioButtonModule } from 'primeng/radiobutton';
import { CheckboxModule } from 'primeng/checkbox';
import { InputMaskModule } from 'primeng/inputmask';
import { MessageModule } from 'primeng/message';
import { PaginatorModule } from 'primeng/paginator';
import { StepsModule } from 'primeng/steps';
import { MessagesModule } from 'primeng/messages';
import { CardModule } from 'primeng/card';
import { FileUploadModule } from 'primeng/fileupload';
import { InplaceModule } from 'primeng/inplace';
// import { GMapModule } from 'primeng/gmap';
import { TreeModule } from 'primeng/tree';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { CarouselModule } from 'primeng/carousel';
import { OrderListModule } from 'primeng/orderlist';
import { ChipsModule } from 'primeng/chips';
import { SelectButtonModule } from 'primeng/selectbutton';

import { QRCodeModule } from 'angularx-qrcode';
import { NgxEditorModule } from 'ngx-editor';

import { AppMenuComponent, AppSubMenuComponent } from './wireframes/app.menu.component';
import { AppBreadcrumbComponent } from './wireframes/app.breadcrumb.component';
import { AppTopBarComponent } from './wireframes/app.topbar.component';
import { AppFooterComponent } from './wireframes/app.footer.component';
import { CoreRoutingModule } from './core-routing.module';
import { ListaComponent } from './list/lista.component';
import { PopoverInputComponent } from './framework/popover-input/popover-input.component';
import { MyDatePipe } from './framework/pipes/mydate.pipe';
import { MyDatetimePipe } from './framework/pipes/mydatetime.pipe';
import { SafePipe } from './framework/pipes/safe.pipe';
import { ResultsetPipe } from './framework/pipes/resultset.pipe';
import { PopoverDropdownlistComponent } from './framework/popover-dropdownlist/popover-dropdownlist.component';
import { AuthGuard } from '../seguranca/authguard';
import { ListHandlerService } from './list/list-handler.service';
import { ItemInventarioService } from '../farmacia/estoque/item-inventario/item-inventario.service';
import { MySelectComponent } from './framework/input-components/my-select/my-select.component';
import { AutocompleteProdutoComponent } from '../farmacia/util/autocomplete-produto/autocomplete-produto.component';
import { UsuarioTokenService } from '../seguranca/usuario/usuario-token/service/usuario-token.service';
import { UsuarioService } from '../seguranca/usuario/usuario/usuario.service';
import { TopbarFilterComponent } from './framework/filters/topbar-filter/topbar-filter.component';
import { TopbarFilterHandlerService } from './framework/filters/topbar-filter/service/topbar-filter-handler.service';
import { RelatorioComponent } from './relatorio/relatorio.component';
import { BottomPanelComponent } from './bottom-panel/bottom-panel.component';
import { AnexoBottomPanelComponent } from './anexo-bottom-panel/anexo-bottom-panel.component';
import { BottomPanelDirective } from './bottom-panel/bottom-panel.directive';
import { AutocompletePacienteComponent } from './autocomplete-components/autocomplete-paciente/autocomplete-paciente.component';
import { PopupDeConfirmacaoDeCancelamentoComponent } from './confirmacao/popup-de-confirmacao-de-cancelamento/popup-de-confirmacao-de-cancelamento.component';
import { OverlayPanelComponent } from './overlay-panel/overlay-panel.component';
import { AddAsteriscoDirective } from './directives/add-asterisco.directive';
import { PoliticaDePrivacidadeListaComponent } from './politica-de-privacidade/politica-de-privacidade-lista/politica-de-privacidade-lista.component';
import { PoliticaDePrivacidadeFormComponent } from './politica-de-privacidade/politica-de-privacidade-form/politica-de-privacidade-form.component';
import { PoliticaDePrivacidadeModalComponent } from './politica-de-privacidade/politica-de-privacidade-modal/politica-de-privacidade-modal.component';
import { PoliticaDePrivacidadeComponent } from '../seguranca/politica-de-privacidade/politica-de-privacidade.component';
import { EnderecoComponent } from '../homecare/gis/endereco/endereco/endereco.component';
import { EnderecoMapaComponent } from '../homecare/gis/endereco/endereco/endereco-mapa/endereco-mapa.component';
import { EnderecoMensagensDeAvisoComponent } from '../homecare/gis/endereco/endereco-mensagens-de-aviso/endereco-mensagens-de-aviso.component';
import { MbscModule } from '@mobiscroll/angular';
import { CurrencyMaskModule } from "ng2-currency-mask";
import { CfgIntegracaoHomeComponent } from './cfg-integracao/components/cfg-integracao-home/cfg-integracao-home.component';
import { CfgIntegracaoEventoComponent } from './cfg-integracao/components/evento/cfg-integracao-evento/cfg-integracao-evento.component';
import { CfgIntegracaoEventoLogComponent } from './cfg-integracao/components/evento/cfg-integracao-evento-log/cfg-integracao-evento-log.component';
import { PopoverEditorUrlComponent } from './cfg-integracao/components/popover-editor-url/popover-editor-url.component';
import { MediaViewerComponent } from './framework/input-components/media-viewer/media-viewer/media-viewer.component';
import { CarregandoIndeterminadoComponent } from './framework/input-components/carregando-indeterminado/carregando-indeterminado.component';
import { TopbarSearchComponent } from './framework/input-components/topbar-search/topbar-search.component';
import { TopbarSearchItemResultadoComponent } from './framework/input-components/topbar-search/components/topbar-search-item-resultado/topbar-search-item-resultado.component';
import { AutocompleteQuestaoComponent } from './autocomplete-components/autocomplete-questao/autocomplete-questao.component';
import { LabelAvatarComponent } from './framework/input-components/label-avatar/label-avatar.component';
import { SumarioPacienteQuadroPerfilQuestaoDestaqueComponent } from './paciente-commons/components/sumario-paciente-quadro-perfil-questao-destaque/sumario-paciente-quadro-perfil-questao-destaque.component';
import { LinksRapidosEQuestoesFavoritasDoPacienteComponent } from './paciente-commons/components/links-rapidos-e-questoes-favoritas-do-paciente/links-rapidos-e-questoes-favoritas-do-paciente.component';
import { CabecalhoDeImpressaoComponent } from './relatorio/components/cabecalho-de-impressao/cabecalho-de-impressao.component';
import { HtmlSafePipe } from './framework/pipes/html-safe.pipe';
import { AssinaturaDigitalDownloadDeConteudoComponent } from './cfg-integracao/components/assinatura-digital/assinatura-digital-download-de-conteudo/assinatura-digital-download-de-conteudo.component';
import { AutocompleteUnidadeComponent } from './autocomplete-components/autocomplete-unidade/autocomplete-unidade.component';
import { RelatorioBaseComponent } from './relatorio/components/relatorio-base/relatorio-base.component';
import { AutocompleteInventarioComponent } from './autocomplete-components/autocomplete-inventario/autocomplete-inventario.component';
import { MyCalendarComponent } from './framework/input-components/my-calendar/my-calendar.component';
import { TagAcessoATodasUnidadesComponent } from './unidade/tag-acesso-a-todas-unidades/tag-acesso-a-todas-unidades.component';
import { AutocompleteQuestionarioComponent } from './autocomplete-components/autocomplete-questionario/autocomplete-questionario.component';


const modules = [
  CommonModule,
  AccordionModule,
  TableModule,
  PanelModule,
  ScrollPanelModule,
  OverlayPanelModule,
  FormsModule,
  ReactiveFormsModule,
  InputTextModule,
  DropdownModule,
  InputSwitchModule,
  AutoCompleteModule,
  CalendarModule,
  TabViewModule,
  MultiSelectModule,
  InputTextareaModule,
  DialogModule,
  FieldsetModule,
  RadioButtonModule,
  CheckboxModule,
  QRCodeModule,
  InputMaskModule,
  MessageModule,
  PaginatorModule,
  StepsModule,
  MessagesModule,
  MatButtonModule,
  DragDropModule,
  MatListModule,
  MatMenuModule,
  OverlayModule,
  MatIconModule,
  MatSidenavModule,
  CardModule,
  FileUploadModule,
  InplaceModule,
  MatRippleModule,
  TreeModule,
  GoogleMapsModule,
  NgxEditorModule,
  MbscModule,
  FormsModule,
  CurrencyMaskModule,
  ProgressSpinnerModule,
  CarouselModule,
  OrderListModule,
  ChipsModule,
  SelectButtonModule
];



@NgModule({
  imports: [
    modules,
    CoreRoutingModule
  ],
  declarations: [
    ResultsetPipe,
    MyDatePipe,
    MyDatetimePipe,
    SafePipe,
    HtmlSafePipe,
    AppMenuComponent,
    AppSubMenuComponent,
    AppBreadcrumbComponent,
    AppTopBarComponent,
    AppFooterComponent,
    ListaComponent,
    PopoverInputComponent,
    PopoverDropdownlistComponent,
    MySelectComponent,
    AutocompleteProdutoComponent,
    AutocompletePacienteComponent,
    AutocompleteQuestaoComponent,
    AutocompleteUnidadeComponent,
    AutocompleteQuestionarioComponent,
    TagAcessoATodasUnidadesComponent,
    AutocompleteInventarioComponent,
    TopbarFilterComponent,
    RelatorioComponent,
    OverlayPanelComponent,
    BottomPanelComponent,
    AnexoBottomPanelComponent,
    BottomPanelDirective,
    PopupDeConfirmacaoDeCancelamentoComponent,
    AddAsteriscoDirective,
    PoliticaDePrivacidadeListaComponent,
    PoliticaDePrivacidadeFormComponent,
    PoliticaDePrivacidadeModalComponent,
    PoliticaDePrivacidadeComponent,
    EnderecoComponent,
    EnderecoMapaComponent,
    EnderecoMensagensDeAvisoComponent,
    CfgIntegracaoEventoComponent,
    CfgIntegracaoHomeComponent,
    CfgIntegracaoEventoLogComponent,
    PopoverEditorUrlComponent,
    MediaViewerComponent,
    CarregandoIndeterminadoComponent,
    TopbarSearchComponent,
    TopbarSearchItemResultadoComponent,
    LabelAvatarComponent,
    SumarioPacienteQuadroPerfilQuestaoDestaqueComponent,
    LinksRapidosEQuestoesFavoritasDoPacienteComponent,
    CabecalhoDeImpressaoComponent,
    AssinaturaDigitalDownloadDeConteudoComponent,
    RelatorioBaseComponent,
    MyCalendarComponent
  ],
  exports: [
    modules,
    RouterModule,
    ResultsetPipe,
    MyDatePipe,
    MyDatetimePipe,
    SafePipe,
    HtmlSafePipe,
    AppMenuComponent,
    AppSubMenuComponent,
    AppBreadcrumbComponent,
    AppTopBarComponent,
    AppFooterComponent,
    ListaComponent,
    PopoverInputComponent,
    PopoverDropdownlistComponent,
    AutocompleteProdutoComponent,
    AutocompletePacienteComponent,
    AutocompleteQuestaoComponent,
    AutocompleteUnidadeComponent,
    AutocompleteQuestionarioComponent,
    TagAcessoATodasUnidadesComponent,
    AutocompleteInventarioComponent,
    TopbarFilterComponent,
    RelatorioComponent,
    OverlayPanelComponent,
    BottomPanelComponent,
    AddAsteriscoDirective,
    PoliticaDePrivacidadeListaComponent,
    PoliticaDePrivacidadeFormComponent,
    PoliticaDePrivacidadeModalComponent,
    PoliticaDePrivacidadeComponent,
    EnderecoComponent,
    EnderecoMapaComponent,
    EnderecoMensagensDeAvisoComponent,
    CfgIntegracaoEventoComponent,
    CfgIntegracaoHomeComponent,
    MediaViewerComponent,
    CarregandoIndeterminadoComponent,
    LabelAvatarComponent,
    SumarioPacienteQuadroPerfilQuestaoDestaqueComponent,
    LinksRapidosEQuestoesFavoritasDoPacienteComponent,
    CabecalhoDeImpressaoComponent,
    RelatorioBaseComponent,
    MySelectComponent,
    MyCalendarComponent
  ],
  providers: [
    AuthGuard,
    ListHandlerService,
    TopbarFilterHandlerService,
    DatePipe,
    CurrencyPipe,
    // ToasterService,
    // AmbienteService,
    ItemInventarioService,
    UsuarioService,
    UsuarioTokenService
  ]
})
export class CoreModule { }
